
import axios, { AxiosInstance } from 'axios';
import { getExhibitionHeader } from "../utils/exhibitionContext";

export interface ExhibitorType {
  id: number;
  name: string;
  require_tin: boolean; 
  
}

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Dynamically attach token before each request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    Object.assign(config.headers, getExhibitionHeader());
    }
    return config;
  },
  (error) => Promise.reject(error)
);

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  total_pages: number;
  current_page: number;
  page_size: number;
  results: T[];
}



const ExhibitorTypeService = {

  getTypes: async (): Promise<ExhibitorType[]> => {
  const response = await api.get('/api/stakeholders/get-exhibitor-types/'); 
  return response.data;
},


  getAll: async (): Promise<PaginatedResponse<ExhibitorType>> => {
    const response = await api.get('/api/stakeholders/exhibitor-types/');
    return response.data;
  },

  async create(data: Omit<ExhibitorType, 'id'>): Promise<ExhibitorType> {
    const response = await api.post('/api/stakeholders/exhibitor-types/create/', data);
    return response.data;
  },

  async update(id: number, data: Omit<ExhibitorType, 'id'>): Promise<ExhibitorType> {
    const response = await api.put(`/api/stakeholders/exhibitor-types/${id}/update/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/api/stakeholders/exhibitor-types/${id}/delete/`);
  },
};

export default ExhibitorTypeService;
